import {getUserLoggedInCookieKey} from '~/config/cookies'
import Cookies from 'js-cookie'

export function hasLoggedInCookie() {
  const cookieKey = getUserLoggedInCookieKey()
  const isLoggedIn = cookieKey ? Cookies.get(cookieKey) : false
  return !!isLoggedIn
}
